import moment from 'moment';

export function downloadFromURL(url: string, filename?: string) {
    let link = document.createElement('a');
    link.download = filename || moment().format('YYYY-MM-DD_HH-mm-ss');
    link.href = url;
    link.click();
};